import * as React from "react";
import ReactTable, { ReactTableColumn } from "../../ReactTable";
import local_settings, { FIELD_PERFORMANCE_MEASUREMENT_SAVED } from "@/lib/localSettings";

const columns: ReactTableColumn<MeasurementsRow>[] = [
    {
        accessor: "name",
        Header: "",
        filterInputPlaceholder: "Measurement name",
        disableFilters: false,
    },
    {
        accessor: "view",
        Header: "View",
        disableFilters: true,
    },
    {
        accessor: "time_s",
        Header: "Time (seconds)",
        disableFilters: true,
    },
];

type MeasurementsRow = {
    name: string;
    view: string;
    time_s: number;
};

type Props = {};

export default class MeasurementsView extends React.Component<Props> {
    getTableData = () => {
        const exists = local_settings.getItem(FIELD_PERFORMANCE_MEASUREMENT_SAVED);
        let data: MeasurementsRow[] = [];

        if (exists) {
            data = JSON.parse(exists);
        }

        return data;
    };

    render() {
        const data = this.getTableData();
        return (
            <div className="num-renders-view">
                <ReactTable data={data} columns={columns} />
            </div>
        );
    }
}
